import posthog from 'posthog-js';
import { watch } from 'vue';
import { usePosthog } from '@/js/composables/usePosthog.js';
import { useDataStore } from '@/js/stores/DataStore.js';

export default {
    install() {
        const key = document.querySelector('meta[name="posthog-api-key"]')?.content;
        if (!key) {
            return;
        }
        usePosthog().posthog.value = posthog.init(key, {
            api_host: 'https://x.eventwise.live',
            defaults: '2026-05-30',
        });

        const posthogClient = usePosthog().posthog.value;
        const dataStore = useDataStore();

        watch(
            () => ({
                account_id: dataStore.get('account.id', null),
                account_name: dataStore.get('account.name', null),
                is_demo_account: dataStore.get('account.features.demo', null),
                event_id: dataStore.get('current_event.id', null),
                event_name: dataStore.get('current_event.name', null),
                roles: dataStore
                    .get('current_user.roles', [])
                    .map((role) => role.name)
                    .join(', '),
                environment: dataStore.get('environment', null),
                app_version: window.Eventwise.version,
                is_eventwise_staff:
                    dataStore.get('current_user.is_admin', null) || dataStore.get('current_user.is_super_admin'),
                is_impersonating: !!window.Auth.sudo,
                impersonator_id: window.Auth.sudo ? window.Auth.sudo.originalUser.id : null,
            }),
            (context) => {
                const availableContext = Object.fromEntries(
                    Object.entries(context).filter(([, value]) => value !== null && value !== undefined)
                );

                posthogClient.register(availableContext);

                for (const property of Object.keys(context)) {
                    if (!(property in availableContext)) {
                        posthogClient.unregister(property);
                    }
                }
            },
            { immediate: true }
        );
    },
};
